//@ts-nocheck
import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Box,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import { useDrag, useDrop } from "react-dnd";
import { get, post } from "requests";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const DraggableFile = ({ file, index, handleRemoveFile }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "5px",
        border: "1px solid #ccc",
        backgroundColor: "white",
        marginBottom: "5px",
        cursor: "move",
      }}
    >
      <span>
        {index + 1}. {file.name}
      </span>
      <i
        style={{ cursor: "pointer", color: "red" }}
        onClick={() => handleRemoveFile(file.id)}
        className="fa fa-times"
      />
    </div>
  );
};

const CombinePDFModel = ({
  selectedFiles,
  showModal,
  hideModal,
  applicationId,
  categories,
  refreshDocuments,
  setIsRefreshing,
  onRemoveFile,
  setSelectedFiles,
  setAlert,
}) => {
  const [category, setCategory] = useState(null);
  const [fileName, setFileName] = useState("");
  const [description, setDescription] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");

  const handleCloseModal = () => {
    hideModal();
    setCategory(null);
    setFileName("");
    setDescription("");
    setErrorMessage("");
  };

  const handleJoinPDFs = async () => {
    const fileIds = selectedFiles.map((file) => file.id);

    if (fileIds.length === 0 || !category || !fileName) {
      setAlert({
        type: "Warning",
        message: `Please Fill out all the required fields.`,
      });

      return;
    }

    setIsRefreshing(true);
    const params = {
      dealApplicationId: applicationId,
      mediaAttachments: fileIds,
      fileCategory: category?.value,
      fileName: `${fileName}.pdf`,
      description,
    };
    await post("mergePDFs", params);
    refreshDocuments();
    setIsRefreshing(false);
    handleCloseModal();
  };

  const handleRemoveFile = (fileId) => {
    onRemoveFile(fileId);
  };

  return (
    <Dialog open={showModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
      <DialogTitle>Combine PDF Documents</DialogTitle>
      <DialogContent>
        {showAlert && (
          <Alert severity="info" onClose={() => setShowAlert(false)} sx={{ marginBottom: "10px" }}>
            {message}
          </Alert>
        )}

        <MDBox mb={2} mt={2} gap={2} display={"flex"} alignItems={"center"}>
          <TextField
            label="FileName"
            variant="outlined"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            error={!!errorMessage}
            helperText={errorMessage}
          />
          <MDTypography fontSize={18}>.pdf</MDTypography>
        </MDBox>

        <MDBox mb={2}>
          <Autocomplete
            value={category}
            onChange={(_, newValue) => setCategory(newValue)}
            options={categories.map((catg) => ({ label: catg, value: catg }))}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField {...params} label="Select a Category" variant="outlined" fullWidth />
            )}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            disableClearable
          />
        </MDBox>

        <MDBox mb={2}>
          <TextField
            label="Description"
            variant="outlined"
            fullWidth
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </MDBox>

        <MDBox mb={2}>
          <MDBox component="span" sx={{ fontWeight: "bold" }}>
            Selected Documents
          </MDBox>
          <div
            style={{
              border: "1px solid grey",
              padding: "10px",
              height: "200px",
              overflowY: "auto",
              marginTop: "10px",
              backgroundColor: "white",
            }}
          >
            {selectedFiles.map((file, index) => (
              <DraggableFile
                key={file.id}
                file={file}
                index={index}
                handleRemoveFile={handleRemoveFile}
              />
            ))}
          </div>
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton onClick={handleCloseModal} color="secondary">
          Cancel
        </MDButton>
        <MDButton onClick={handleJoinPDFs} color="primary">
          Submit
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default CombinePDFModel;
